import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import { setData, setIsSaveDraft } from '../../../features/aiBotSlice';
import PageTitle from '../PageTitle';
import BrandName from './BrandName';
import CompetingProductsResponse from './CompetingProductsResponse';
import NoAnswerResponse from './NoAnswerResponse';
import NoFileResponse from './NoFileResponse';
import ReplyRule from './ReplyRule';
import ReplySourceUrl from './ReplySourceUrl';
import ResponseRule from './ResponseRule';
import RoleDescription from './RoleDescription';

const useStyles = makeStyles(
  {
    root: {},
    hr: {
      height: 1,
      width: '100%',
      backgroundColor: color.$9,
      margin: '24px 0 16px',
    },
  },
  {
    name: 'BasicSettingContainer',
  },
);

const BasicSettingContainer = ({ pathKey }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { data, isSaved } = useSelector(store => store.aiBot);
  const {
    model,
    brandName,
    roleDescription,
    noAnswerMessage,
    replyTemplate,
    competitors,
    replySourceUrl,
    replyRule,
    noFileMessage,
  } = data;

  const handleChange = value => {
    dispatch(setData(value));
    dispatch(setIsSaveDraft(true));
  };

  return (
    <div className={classes.root}>
      <PageTitle title={t(`${pathKey}:advanceSetting`)} />
      <BrandName
        onChange={v => handleChange({ brandName: v })}
        value={brandName}
        isSaved={isSaved}
      />
      <NoAnswerResponse
        onChange={v => handleChange({ noAnswerMessage: v })}
        value={noAnswerMessage}
        isSaved={isSaved}
      />
      <NoFileResponse
        onChange={v => handleChange({ noFileMessage: v })}
        value={noFileMessage}
        isSaved={isSaved}
      />
      {/* 競品相關回覆設定 */}
      <CompetingProductsResponse
        onChange={v =>
          handleChange({
            competitors: {
              ...competitors,
              ...v,
            },
          })
        }
        value={competitors?.replyMessage}
        tags={competitors?.values}
        isChecked={competitors?.enabled}
        onSwitchChange={() => {
          handleChange({
            competitors: {
              ...competitors,
              enabled: !competitors?.enabled,
            },
          });
        }}
        isSaved={isSaved}
      />
      {/* 角色設置 */}
      <RoleDescription
        onChange={v =>
          handleChange({ roleDescription: { ...roleDescription, value: v } })
        }
        model={model}
        value={roleDescription?.value}
        isChecked={roleDescription?.enabled}
        onSwitchChange={() => {
          handleChange({
            roleDescription: {
              ...roleDescription,
              enabled: !roleDescription?.enabled,
            },
          });
        }}
        isSaved={isSaved}
      />
      {/* 回應規則指令 */}
      <ReplyRule
        onChange={v => handleChange({ replyRule: { ...replyRule, value: v } })}
        model={model}
        value={replyRule?.value || ''}
        isChecked={!!replyRule?.enabled}
        onSwitchChange={() => {
          handleChange({
            replyRule: {
              ...replyRule,
              enabled: !replyRule?.enabled,
            },
          });
        }}
        isSaved={isSaved}
      />
      {/* 回應規則 */}
      <ResponseRule
        onChange={v =>
          handleChange({ replyTemplate: { ...replyTemplate, value: v } })
        }
        value={replyTemplate?.value}
        isChecked={replyTemplate?.enabled}
        onSwitchChange={() => {
          handleChange({
            replyTemplate: {
              ...replyTemplate,
              enabled: !replyTemplate?.enabled,
            },
          });
        }}
        isSaved={isSaved}
      />
      <ReplySourceUrl
        onChange={v =>
          handleChange({ replySourceUrl: { ...replySourceUrl, wording: v } })
        }
        value={replySourceUrl?.wording}
        isChecked={replySourceUrl?.enabled}
        onSwitchChange={() => {
          handleChange({
            replySourceUrl: {
              ...replySourceUrl,
              enabled: !replySourceUrl?.enabled,
            },
          });
        }}
        isSaved={isSaved}
      />
    </div>
  );
};

export default BasicSettingContainer;
